import { useMemo } from "react";

export const htmlConvert = (html = "") => {
    if (!html) return "";

    const fixed = html.replace(/(\S)(<\/p>)/g, "$1 $2");

    const parser = new DOMParser();
    const doc = parser.parseFromString(fixed, "text/html");

    return doc.body.textContent || "";
};
